import { useState } from 'react'

import { PageViewAnalytics } from '~/components/PageViewAnalytics'
import HeroGridList from '~/components/UI/HeroGridList'
import IndexList from '~/components/UI/IndexList'
import IndexListAlphabetFilters from '~/components/UI/IndexList/IndexListAlphabetFilters'

import getDesignerListStaticPropsFunction from '~/data/designer-list-page-data'
import { DesignerListPageData } from '~/data/designer-list-page-data/serializer'

import css from './styles.module.scss'

function DesignerListPage({ hero, grid, lettersList }: DesignerListPageData) {
  const [currentLetter, setCurrentLetter] = useState(null)

  const onChangeLetter = (letter) => {
    if (letter === currentLetter) {
      setCurrentLetter(null)
    } else {
      setCurrentLetter(letter)
    }
  }

  return (
    <>
      <section className={css.DesignerListPage}>
        <div className={css.content}>
          {hero && (
            <HeroGridList {...hero} childrenClassName={css.filterAlphabet}>
              {lettersList && (
                <IndexListAlphabetFilters
                  onClickLetter={(value) => {
                    onChangeLetter(value)
                  }}
                  currentLetter={currentLetter}
                  {...lettersList}
                />
              )}
            </HeroGridList>
          )}

          {grid && (
            <IndexList
              hasAlphabetFilter
              hasMultipleImages
              currentLetter={currentLetter}
              {...grid}
            />
          )}
        </div>
      </section>
      <PageViewAnalytics template="collection" />
    </>
  )
}

export default DesignerListPage

export const getStaticProps = getDesignerListStaticPropsFunction()
